import axios from "axios";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";

export const live = "https://api.fazter.com";
// export const live = "http://localhost:4001";

export const hostedAuthAxios = axios.create({
  baseURL: `${live}/auth`,
});

export const hostedQuoteAxios = axios.create({
  baseURL: `${live}/quote`,
});
export const hostedCampginsAxios = axios.create({
  baseURL: `${live}/campaign`,
});

export const hostedSellerAuthAxios = axios.create({
  baseURL: `${live}/seller-auth`,
});

export const hostedPermissionAxios = axios.create({
  baseURL: `${live}/permission`,
});

export const hostedProductAxios = axios.create({
  baseURL: `${live}/product`,
});
export const hostedSellerProductAxios = axios.create({
  baseURL: `${live}/sellerProduct`,
});

export const hostedCategoryAxios = axios.create({
  baseURL: `${live}/category`,
});

export const hostedCouponAxios = axios.create({
  baseURL: `${live}/coupon`,
});
export const hostedForumCategoryAxios = axios.create({
  baseURL: `${live}/forum`,
});

export const hostedOrderAxios = axios.create({
  baseURL: `${live}/seller-order`,
});
export const hostedPagesAxios = axios.create({
  baseURL: `${live}`,
});
export const hostedNewsletter = axios.create({
  baseURL: `${live}/news-letter`,
});
export const hostedCommonModule = axios.create({
  baseURL: `${live}/common`,
});
export const hostedBulkOrder = axios.create({
  baseURL: `${live}/bulk-order`,
});
export const hostedRatingReview = axios.create({
  baseURL: `${live}/feedback/ratingandreview`,
});

export const hostedLandingPageIndiaAxios = axios.create({
  baseURL: `${live}/landingpage-india`,
});
export const hostedIndiaProductAxios = axios.create({
  baseURL: `${live}/india-product`,
});
export const hostedIndiaCategoryAxios = axios.create({
  baseURL: `${live}/india-category`,
});
export const hostedIndiaBlogAxios = axios.create({
  baseURL: `${live}/india-blog`,
});
export const hostedIndiaNewsletterAxios = axios.create({
  baseURL: `${live}/india-newsletter`,
});
export const hostedContactIndiaAxios = axios.create({
  baseURL: `${live}/contact-india`,
});

/* Shiprocket-backed India shipping module. The module mounts its routes
 * under /api/shipping on the same backend host. */
export const hostedIndiaShippingAxios = axios.create({
  baseURL: `${live}/api/shipping`,
});

/* India product reviews — admin endpoints for the moderation queue
 * (approve / reject / delete pending submissions). Public list and
 * submit endpoints are called by the storefront directly; this axios
 * instance is only used by the back-office. */
export const hostedIndiaReviewAxios = axios.create({
  baseURL: `${live}/india-review`,
});

/* India stock-notify — admin listing + mark-notified + delete for the
 * "Notify me when back in stock" queue. Public submit endpoint is hit
 * by the storefront directly; this axios instance is only used by the
 * back-office. */
export const hostedIndiaStockNotifyAxios = axios.create({
  baseURL: `${live}/india-stock-notify`,
});

/* India auth — admin surface for the registered India customer list
 * (list, toggle active, delete). Login/register/etc are hit by the
 * storefront directly; this instance is only for the dashboard's
 * admin views. */
export const hostedIndiaAuthAxios = axios.create({
  baseURL: `${live}/india-auth`,
});

/* India sellers — admin-managed collection. Each product picks its
 * seller from this collection at save time; the embedded seller block
 * on the product is a snapshot taken from the selected seller. */
export const hostedIndiaSellerAxios = axios.create({
  baseURL: `${live}/india-seller`,
});

/* India coupons — Phase 1 admin CRUD + public validate/applicable. */
export const hostedIndiaCouponAxios = axios.create({
  baseURL: `${live}/india-coupon`,
});

/* India WhatsApp Notify — admin-only surface for abandoned-cart and
 * failed-payment WhatsApp outreach. The "send" flow prepares a wa.me
 * link and logs the notification; admin opens the link in WhatsApp
 * Web / desktop and sends manually (no WhatsApp Business API). */
export const hostedIndiaWhatsappNotifyAxios = axios.create({
  baseURL: `${live}/india-whatsapp-notify`,
});

/* India FAQ — admin CRUD for per-page (home / category / product)
 * FAQs that render inside the storefront's shared bs-wide/bs-faqs
 * block via <IndiaFaqs> on /in, /in/category/<slug>, /in/products/<slug>. */
export const hostedIndiaFaqAxios = axios.create({
  baseURL: `${live}/india-faq`,
});

/* India Bulk-Order Quotes — admin surface for the leads submitted
 * from the <BulkQuoteModal> on PDPs (Request Query button). List,
 * view, status change, delete. */
export const hostedIndiaBulkQuoteAxios = axios.create({
  baseURL: `${live}/india-bulk-quote`,
});

export function useQuery() {
  const { search } = useLocation();
  // return new URLSearchParams(search)
  return useMemo(() => new URLSearchParams(search), [search]);
}
